import { getElements, ifSelectorExist } from './utils';

export const bruniTabs = () => {

  const tabsAreas = getElements(".areas-bruni__tabs--item");
  const contentsAreas = getElements(".areas-bruni__content--item");

  if (ifSelectorExist(tabsAreas) && ifSelectorExist(contentsAreas)) {
    if (tabsAreas.length > 0 && contentsAreas.length > 0) {
      tabsAreas[0].classList.add("active");
      contentsAreas[0].classList.add("active");
    }

    tabsAreas.forEach((tab, index) => {
      tab.addEventListener("click", function () {
        tabsAreas.forEach(t => t.classList.remove("active"));
        contentsAreas.forEach(c => c.classList.remove("active"));
        tab.classList.add("active");
        contentsAreas[index].classList.add("active");
      });
    });
  }
}
